import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/messaging'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueSignaturePad from 'vue-signature-pad'
import Vuelidate from 'vuelidate'
import App from './App.vue'
// import internetSpeedInterceptor from './internetSpeedInterceptor'

import environment from './environment'
import firebaseConfig from './firebaseConfig'
import recipeHelpers from '@/helpers/helpers'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/helpers/filters'
import './assets/css/main.css'


/* Axios */
export const axiosInstance = axios.create({})

export const eventBus = new Vue();

axiosInstance.interceptors.request.use(
  (config) => {
    config.metadata = { startTime: new Date() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const endTime = new Date();
    const startTime = response.config.metadata.startTime;
    const timeTaken = endTime - startTime;
    console.log('Tiempo de respuesta:', timeTaken, 'ms');

    const threshold = 2000;

    if (timeTaken > threshold) {
      eventBus.$emit('badConnection')     
    } else {
      eventBus.$emit('goodConnection')
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);


/* Firebase */
firebase.initializeApp(firebaseConfig)
if (firebase.messaging.isSupported()) {
  const messaging = firebase.messaging()
  messaging.usePublicVapidKey('BDs850fRFwuynM1ylK3VLZldO3g3FdXyXIhrXRWv8EWar-u8Nip7V-5C0na4uepwP6eoYK3U68JpK91Y87O8vDA')
}


/* Sentry */
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIROMENT,
  release: `${process.env.VUE_APP_SENTRY_RELEASE}@${process.env.VUE_APP_VERSION}`,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', /^\//],
    }),
    new Sentry.Replay(
      {
        networkDetailAllowUrls: [
          window.location.origin,
          'https://backend.rapihogar.com.ar/',
          'https://backend.rapihogar.com.ar/v2/mobile/autologin/',
          'https://backend.rapihogar.com.ar/v2/mobile/request_technician/',
          'https://backend.rapihogar.com.ar/v2/mobile/notification/',
          'https://backend.rapihogar.com.ar/v2/mobile/notification_fcm/subscribe/'
        ],
        networkRequestHeaders: ['Cache-Control'],
        networkResponseHeaders: ['Referrer-Policy'],
      }
    ),
  ],

  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const plugin = {
  install() {
    Vue.helpers = recipeHelpers
    Vue.prototype.$helpers = recipeHelpers
  }
}

Vue.use(Vuelidate)
Vue.use(VueAxios, axiosInstance)
Vue.use(VueSignaturePad)
Vue.use(plugin)

Vue.prototype.$environment = environment

Vue.config.productionTip = false
let app
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
